import styles from './AddToCalendarIcon.scss';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import React from 'react';

const AddToCalendarIcon = () => {
  return (
    <span className={styles.addToCalendarIcon}>
      <CalendarTodayOutlinedIcon className={styles.calendarTodayIcon} />
      <AddOutlinedIcon className={styles.addIcon}/>
    </span>
  );
};

export default AddToCalendarIcon;
